var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Modal,_vm._g({staticClass:"detail-modal",attrs:{"data-testid":_setup.testId,"is-open":_vm.isOpen,"size":"md","title":_vm.title}},_vm.$listeners),[_c(_setup.getComponent,{tag:"component",attrs:{"modal-info":_vm.detailProps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }